module.exports = "./dist/assets/images/icons/41617c6dd490dcea95898d18ae8d0cc0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/logo_viebrock.png
// module id = ./assets/images/icons/logo_viebrock.png
// module chunks = 0